/* eslint-disable no-undef */
class CartRemoveButton extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
      cartItems.updateQuantity(this.dataset.index, 0)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor () {
    super()

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus')

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))
  }

  onChange (event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
  }

  getSectionsToRender () {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ]
  }

  updateQuantity (line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      /* eslint-disable-next-line camelcase */
      sections_url: window.location.pathname,
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        this.classList.toggle('is-empty', parsedState.item_count === 0)
        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        })

        // Dispatch cart updated event for roof bar modal
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }))

        this.updateLiveRegions(line, parsedState.item_count)
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`)
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus()
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading()
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'))
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
        this.disableLoading()
      })
  }

  updateLiveRegions (line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`)
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`)
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value,
        )
    }

    this.currentItemCount = itemCount
    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML (html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  enableLoading (line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`)
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'))

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading () {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.remove('cart__items--disabled')
  }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor () {
      super()

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value })
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      }, 300))
    }
  })
}

// Enhanced CartDrawerItems class with loading support for new grid items
class CartDrawerItems extends CartItems {
  getSectionsToRender () {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }

  enableLoading (line) {
    // Call parent method for existing functionality
    super.enableLoading(line)

    // Enable loading for new grid-based cart items
    const newCartItems = this.querySelectorAll('.cart-drawer__cart-item')
    if (newCartItems.length > 0 && line <= newCartItems.length) {
      const cartItem = newCartItems[line - 1]
      if (cartItem) {
        cartItem.classList.add('cart-drawer__cart-item--loading')
        cartItem.setAttribute('data-loading', 'true')

        // Enable loading on quantity selector
        const quantitySelector = cartItem.querySelector('quantity-selector')
        if (quantitySelector) {
          quantitySelector.enableLoading()
        }

        // Enable loading on remove button
        const removeButton = cartItem.querySelector('cart-drawer-remove-button')
        if (removeButton) {
          removeButton.enableLoading()
        }
      }
    }
  }

  disableLoading () {
    // Call parent method for existing functionality
    super.disableLoading()

    // Disable loading for new grid-based cart items
    const newCartItems = this.querySelectorAll('.cart-drawer__cart-item--loading, .cart-drawer__cart-item[data-loading="true"]')
    newCartItems.forEach(cartItem => {
      cartItem.classList.remove('cart-drawer__cart-item--loading')
      cartItem.removeAttribute('data-loading')

      // Disable loading on quantity selector
      const quantitySelector = cartItem.querySelector('quantity-selector')
      if (quantitySelector) {
        quantitySelector.disableLoading()
      }

      // Disable loading on remove button
      const removeButton = cartItem.querySelector('cart-drawer-remove-button')
      if (removeButton) {
        removeButton.disableLoading()
      }
    })
  }

  getSectionInnerHTML (html, selector) {
    const innerHTML = super.getSectionInnerHTML(html, selector)

    setTimeout(() => {
      this.initializeCustomElements()
      if (window.tentboxInitCartDrawerFaders) window.tentboxInitCartDrawerFaders(document)
    }, 0)

    return innerHTML
  }

  initializeCustomElements () {
    // Custom elements with connectedCallback will reinitialize automatically
    // when they're re-added to the DOM, so we don't need to do anything special here
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)

function initCartDrawerFaders (root = document) {
  const containers = root.querySelectorAll('#CartDrawer-Form, [data-scroll-container="true"], .cart-drawer__empty')
  containers.forEach((container) => {
    const topFader = container.querySelector('.cart-drawer__fader--top')
    const bottomFader = container.querySelector('.cart-drawer__fader--bottom')
    if (!topFader && !bottomFader) return

    if (container._faderObserver) {
      try { container._faderObserver.disconnect() } catch (e) {}
      container._faderObserver = null
    }

    const isScrollable = container.scrollHeight > container.clientHeight
    if (!isScrollable) {
      if (topFader) topFader.classList.remove('show')
      if (bottomFader) bottomFader.classList.remove('show')
    } else {
      if (topFader) topFader.classList.add('show')
      if (bottomFader) bottomFader.classList.add('show')
    }

    const topSentinel = container.querySelector('.cart-drawer__sentinel--top')
    const bottomSentinel = container.querySelector('.cart-drawer__sentinel--bottom')
    if (topSentinel && bottomSentinel && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === topSentinel) {
            if (entry.isIntersecting) {
              if (topFader) topFader.classList.remove('show')
            } else {
              if (topFader) topFader.classList.add('show')
            }
          } else if (entry.target === bottomSentinel) {
            if (entry.isIntersecting) {
              if (bottomFader) bottomFader.classList.remove('show')
            } else {
              if (bottomFader) bottomFader.classList.add('show')
            }
          }
        }
      }, { root: container, threshold: 0.01 })

      container._faderObserver = observer
      observer.observe(topSentinel)
      observer.observe(bottomSentinel)
      container.dataset.fadersInit = 'true'
      return
    }

    const onScroll = () => {
      const maxScroll = container.scrollHeight - container.clientHeight
      const showTop = container.scrollTop > 0
      const showBottom = container.scrollTop < (maxScroll - 1)
      if (topFader) topFader.classList.toggle('show', showTop)
      if (bottomFader) bottomFader.classList.toggle('show', showBottom)
    }

    container.addEventListener('scroll', onScroll, { passive: true })
    container.dataset.fadersInit = 'true'
    setTimeout(onScroll, 0)
  })
}

window.tentboxInitCartDrawerFaders = initCartDrawerFaders

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawerFaders(document)
})

// QuantitySelector custom element (shared between drawer and main cart if used)
if (!customElements.get('quantity-selector')) {
  class QuantitySelector extends HTMLElement {
    // no-op constructor

    connectedCallback () {
      this.button = this.querySelector('[data-quantity-button]')
      this.dropdown = this.querySelector('.cart-drawer__quantity-dropdown')
      this.currentSpan = this.querySelector('.cart-drawer__quantity-current')
      this.itemKey = this.dataset.itemKey
      this.lineIndex = parseInt(this.dataset.lineIndex)

      if (this.button && this.dropdown) {
        this.init()
      }
    }

    init () {
      this.button.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.toggleDropdown()
      })

      this.dropdown.addEventListener('click', (e) => {
        const quantityButton = e.target.closest('[data-quantity-value]')
        if (quantityButton) {
          e.preventDefault()
          e.stopPropagation()
          const newQuantity = parseInt(quantityButton.dataset.quantityValue)
          this.updateQuantity(newQuantity)
          this.closeDropdown()
        }
      })

      // Manage fader visibility on scroll
      const list = this.dropdown.querySelector('.cart-drawer__quantity-list')
      const fader = this.dropdown.querySelector('.cart-drawer__quantity-fader')
      const updateFader = () => {
        if (!list || !fader) return
        const isScrollable = list.scrollHeight > list.clientHeight
        const atBottom = Math.ceil(list.scrollTop + list.clientHeight) >= list.scrollHeight
        fader.style.opacity = (!isScrollable || atBottom) ? '0' : '1'
      }
      if (list) {
        list.addEventListener('scroll', updateFader)
        // initialize after first paint
        setTimeout(updateFader, 0)
      }

      document.addEventListener('click', (e) => {
        if (!e.target.closest(`[data-item-key="${this.itemKey}"] .cart-drawer__cart-item-quantity`)) {
          this.closeDropdown()
        }
      })
    }

    toggleDropdown () {
      const isOpen = !this.dropdown.classList.contains('hidden')
      document.querySelectorAll('.cart-drawer__quantity-dropdown').forEach((d) => d.classList.add('hidden'))
      document.querySelectorAll('[data-quantity-button]').forEach((b) => b.setAttribute('aria-expanded', 'false'))
      if (!isOpen) {
        if (!this.isButtonVisible()) return
        this.dropdown.classList.remove('hidden')
        this.dropdown.style.visibility = 'hidden'
        this.positionDropdown()
        this.dropdown.style.visibility = ''
        this.button.setAttribute('aria-expanded', 'true')
      }
    }

    closeDropdown () {
      this.dropdown.classList.add('hidden')
      this.button.setAttribute('aria-expanded', 'false')
    }

    getScrollContainer () {
      // Only use scroll container if it's an ancestor of this element
      // Don't use document.querySelector as it might find the cart drawer on the cart page
      return this.closest('[data-scroll-container="true"]') || document
    }

    isButtonVisible () {
      const container = this.getScrollContainer()
      const buttonRect = this.button.getBoundingClientRect()

      // If container is document (cart page case), check viewport visibility
      if (container === document || container === document.documentElement) {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth
        const fullyVisibleVertically = buttonRect.top >= 0 && buttonRect.bottom <= viewportHeight
        const horizontallyVisible = buttonRect.right > 0 && buttonRect.left < viewportWidth
        return fullyVisibleVertically && horizontallyVisible
      }

      // Original logic for scroll containers (cart drawer case)
      const containerRect = container.getBoundingClientRect()
      const fullyVisibleVertically = buttonRect.top >= containerRect.top && buttonRect.bottom <= containerRect.bottom
      const horizontallyVisible = buttonRect.right > containerRect.left && buttonRect.left < containerRect.right
      return fullyVisibleVertically && horizontallyVisible
    }

    positionDropdown () {
      const container = this.getScrollContainer()
      const buttonRect = this.button.getBoundingClientRect()

      this.dropdown.classList.remove('cart-drawer__quantity-dropdown--top')
      this.dropdown.classList.remove('mb-1')
      this.dropdown.classList.add('mt-1')

      const dropdownHeight = this.dropdown.getBoundingClientRect().height || 0
      let spaceBelow, spaceAbove

      // If container is document (cart page case), use viewport
      if (container === document || container === document.documentElement) {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight
        spaceBelow = viewportHeight - buttonRect.bottom
        spaceAbove = buttonRect.top
      } else {
        // Original logic for scroll containers (cart drawer case)
        const containerRect = container.getBoundingClientRect()
        spaceBelow = containerRect.bottom - buttonRect.bottom
        spaceAbove = buttonRect.top - containerRect.top
      }

      const shouldFlipToTop = spaceBelow < dropdownHeight + 8 && spaceAbove > spaceBelow
      if (shouldFlipToTop) {
        this.dropdown.classList.add('cart-drawer__quantity-dropdown--top')
        this.dropdown.classList.remove('mt-1')
        this.dropdown.classList.add('mb-1')
      }
    }

    updateQuantity (newQuantity) {
      const container = this.closest('cart-drawer-items, cart-items') || document.querySelector('cart-drawer-items') || document.querySelector('cart-items')
      if (container && this.lineIndex > 0) {
        this.enableLoading()
        container.updateQuantity(this.lineIndex, newQuantity)
      }
    }

    enableLoading () {
      const cartItem = this.closest('.cart-drawer__cart-item')
      if (cartItem) {
        cartItem.classList.add('cart-drawer__cart-item--loading')
        cartItem.setAttribute('data-loading', 'true')
      }
    }

    disableLoading () {
      const cartItem = this.closest('.cart-drawer__cart-item')
      if (cartItem) {
        cartItem.classList.remove('cart-drawer__cart-item--loading')
        cartItem.removeAttribute('data-loading')
      }
    }

    updateCurrentValue (quantity) {
      if (this.currentSpan) this.currentSpan.textContent = quantity
      this.querySelectorAll('[data-quantity-value]').forEach((option) => {
        const value = parseInt(option.dataset.quantityValue)
        if (value === quantity) {
          option.classList.add('bg-oat', 'font-medium')
          option.setAttribute('aria-selected', 'true')
        } else {
          option.classList.remove('bg-oat', 'font-medium')
          option.setAttribute('aria-selected', 'false')
        }
      })
    }
  }
  customElements.define('quantity-selector', QuantitySelector)
}

// Remove button custom element (shared)
if (!customElements.get('cart-drawer-remove-button')) {
  class CartDrawerRemoveButton extends HTMLElement {
    // no-op constructor

    connectedCallback () {
      this.button = this.querySelector('[data-remove-item]')
      this.itemKey = this.dataset.itemKey
      this.lineIndex = parseInt(this.dataset.lineIndex)
      if (this.button) this.init()
    }

    init () {
      this.button.addEventListener('click', (e) => {
        e.preventDefault()
        const container = this.closest('cart-drawer-items, cart-items') || document.querySelector('cart-drawer-items') || document.querySelector('cart-items')
        if (container && this.lineIndex > 0) {
          this.enableLoading()
          const cartItem = this.closest('.cart-drawer__cart-item')
          if (cartItem) cartItem.classList.add('cart-drawer__cart-item--loading')
          container.updateQuantity(this.lineIndex, 0)
        }
      })
    }

    enableLoading () {
      if (this.button) this.button.disabled = true
    }

    disableLoading () {
      if (this.button) this.button.disabled = false
    }
  }
  customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton)
}

// Cart Cross-sell Button with Variant Selection
if (!customElements.get('cart-cross-sell-button')) {
  class CartCrossSellButton extends HTMLElement {
    // no-op constructor

    connectedCallback () {
      this.button = this.querySelector('button')
      this.productId = this.dataset.productId
      this.productHandle = this.dataset.productHandle
      this.productTitle = this.dataset.productTitle
      this.hasMultipleVariants = this.dataset.hasMultipleVariants === 'true'
      this.variantIds = this.dataset.variantIds ? this.dataset.variantIds.split(',') : []
      this.optionsName = this.dataset.optionsName
      this.cardId = this.dataset.cardId

      // Create custom modal if we have multiple variants
      if (this.hasMultipleVariants) {
        this.createCustomModal()
      }

      if (this.button) this.init()
    }

    createCustomModal () {
      // Add required CSS styles for the modal
      if (!document.getElementById('cart-cross-sell-modal-styles')) {
        const style = document.createElement('style')
        style.id = 'cart-cross-sell-modal-styles'
        style.textContent = `
          .cart-cross-sell-modal[data-open='false'] {
            visibility: hidden;
            opacity: 0;
            pointer-events: none;
            transition: visibility 0s linear 0.4s, opacity 0.2s;
          }

          .cart-cross-sell-modal[data-open='true'] {
            visibility: visible;
            opacity: 1;
            pointer-events: auto;
            transition: visibility 0s linear 0s, opacity 0.2s;
          }

          @media only screen and (max-width: 900px) {
            .cart-cross-sell-modal .cart-cross-sell-modal__content {
              transform: translateY(100%);
              transition: transform 0.2s 0s ease;
            }

            .cart-cross-sell-modal[data-open='true'] .cart-cross-sell-modal__content {
              transform: translateY(0);
              transition: transform 0.2s 0.1s ease;
            }
          }

          .cart-cross-sell-modal svg {
            width: 100%;
            height: 100%;
          }
        `
        document.head.appendChild(style)
      }

      // Create modal HTML structure matching reusable modal exactly
      this.modal = document.createElement('div')
      this.modal.className = 'cart-cross-sell-modal relative z-[99999999999] md:z-[99999999999]'
      this.modal.setAttribute('data-open', 'false')

      this.modal.innerHTML = `
        <div class="cart-cross-sell-modal__container fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div class="cart-cross-sell-modal__content overscroll-contain bg-white rounded-lg max-h-[80vh] min-h-[200px] max-w-[800px] min-w-[300px] w-full md:w-auto overflow-hidden flex flex-col p-4 md:p-4 fixed md:relative bottom-0 md:bottom-auto rounded-b-none md:rounded-b-lg">
            <div class="cart-cross-sell-modal__header grid grid-cols-[1fr,32px] gap-4 justify-between items-center w-full mb-4 border-b border-clay pb-2 select-none">
              <div class="cart-cross-sell-modal__title !inline-flex items-center text-lg font-body font-semibold h-[32px]">
                Select ${this.optionsName}
              </div>
              <button type="button" class="cart-cross-sell-modal__close text-xl leading-none w-8 h-8 p-1 flex items-center justify-center self-start bg-white rounded-full" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
            <div class="cart-cross-sell-modal__body-wrapper overflow-y-auto flex-grow relative">
              <div class="cart-cross-sell-modal__body">
                <div class="cart-cross-sell-modal__options"></div>
              </div>
            </div>
          </div>
        </div>
      `

      // Add modal to body
      document.body.appendChild(this.modal)

      // Add event listeners
      // Overlay click (click on container but not content)
      const container = this.modal.querySelector('.cart-cross-sell-modal__container')
      container.addEventListener('click', (e) => {
        if (e.target === container) {
          this.hideModal()
        }
      })

      this.modal.querySelector('.cart-cross-sell-modal__close').addEventListener('click', () => {
        this.hideModal()
      })

      // ESC key to close
      this.handleEscapeKey = (e) => {
        if (e.key === 'Escape' && this.modal.getAttribute('data-open') === 'true') {
          this.hideModal()
        }
      }
      document.addEventListener('keydown', this.handleEscapeKey)
    }

    init () {
      this.button.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        if (this.hasMultipleVariants) {
          this.handleMultipleVariants()
        } else {
          // Single variant - add directly to cart
          this.addSingleVariantToCart()
        }
      })
    }

    async handleMultipleVariants () {
      this.enableLoading()

      try {
        const variantData = await this.fetchVariantData(this.variantIds)
        this.openVariantModal(variantData)
      } catch (error) {
        console.error('Error fetching variant data:', error)
        this.showError('Failed to load product variants')
      } finally {
        this.disableLoading()
      }
    }

    async fetchVariantData (variantIds) {
      const variantData = []
      let successfulFetches = 0

      // First, try the variant endpoint approach
      for (const id of variantIds) {
        try {
          const response = await fetch(`/variants/${id}.json`)

          if (!response.ok) {
            continue
          }

          const data = await response.json()
          variantData.push({
            title: data.product_variant.title,
            price: data.product_variant.price,
            id: String(data.product_variant.id),
            available: data.product_variant.available,
          })
          successfulFetches++
        } catch (error) {
          console.error(`[Cart Cross-sell] Error fetching variant ${id}:`, error)
        }
      }

      // If individual variant fetching failed, try fallback method using product data
      if (successfulFetches === 0) {
        const productEndpoints = []
        if (this.productHandle) productEndpoints.push(`/products/${this.productHandle}.js`)
        if (this.productId) productEndpoints.push(`/products/${this.productId}.js`)

        for (const endpoint of productEndpoints) {
          try {
            const response = await fetch(endpoint)

            if (response.ok) {
              const productData = await response.json()

              // Extract variant data from product
              productData.variants?.forEach(variant => {
                if (variantIds.includes(String(variant.id)) && variant.available) {
                  variantData.push({
                    title: variant.title,
                    price: variant.price,
                    id: String(variant.id),
                    available: variant.available,
                  })
                }
              })

              // If we got data, break out of the loop
              if (variantData.length > 0) break
            }
          } catch (error) {
            console.error(`[Cart Cross-sell] Fallback method failed for ${endpoint}:`, error)
          }
        }
      }

      return variantData.filter(variant => variant.available !== false)
    }

    openVariantModal (variantData) {
      if (!this.modal) {
        console.error('[Cart Cross-sell] Custom modal not found')
        return
      }

      const modalOptionsElement = this.modal.querySelector('.cart-cross-sell-modal__options')

      // Check if we have variant data
      if (!variantData || variantData.length === 0) {
        console.error('[Cart Cross-sell] No variant data available')
        modalOptionsElement.innerHTML = '<div class="text-center p-4 text-iron">No variants available</div>'
        this.showModal()
        return
      }

      // Create variant selection buttons
      let variantButtons = ''
      variantData.forEach((variant) => {
        const formattedPrice = this.formatPrice(variant.price)

        variantButtons += `
          <button 
            type="button" 
            class="cart-cross-sell-modal__variant-button flex rounded overflow-hidden border border-clay items-center justify-between gap-2 mb-2 py-2 px-3 hover:bg-oat transition-colors"
            data-variant-id="${variant.id}"
            data-variant-title="${variant.title}"
            data-variant-price="${variant.price}"
          >
            <span class="cart-cross-sell-modal__variant-title text-sm font-body flex-grow text-left font-normal pointer-events-none">
              ${variant.title}
            </span>
            <span class="cart-cross-sell-modal__variant-price text-sm font-normal pointer-events-none">
              ${formattedPrice}
            </span>
          </button>
        `
      })

      const modalContent = `
        <div class="cart-cross-sell-modal__content-wrapper flex flex-col gap-4">
          <div class="cart-cross-sell-modal__description text-sm text-iron">
            Choose your ${this.optionsName.toLowerCase()} option:
          </div>
          <div class="cart-cross-sell-modal__variants-list grid grid-cols-1 w-full gap-2">
            ${variantButtons}
          </div>
        </div>
      `

      modalOptionsElement.innerHTML = modalContent

      // Add event listeners for variant buttons (remove any existing listeners first)
      const existingHandler = this.variantClickHandler
      if (existingHandler) {
        modalOptionsElement.removeEventListener('click', existingHandler)
      }

      this.variantClickHandler = (e) => {
        const variantButton = e.target.closest('.cart-cross-sell-modal__variant-button[data-variant-id]')
        if (variantButton) {
          const variantId = variantButton.dataset.variantId
          this.addVariantToCart(variantId)
          this.hideModal()
        }
      }

      modalOptionsElement.addEventListener('click', this.variantClickHandler)

      // Show modal
      this.showModal()
    }

    showModal () {
      if (this.modal) {
        this.modal.setAttribute('data-open', 'true')

        // Prevent body scroll but don't interfere with cart drawer scroll management
        if (!document.body.style.overflow) {
          document.body.style.overflow = 'hidden'
        }
      }
    }

    hideModal () {
      if (this.modal) {
        this.modal.setAttribute('data-open', 'false')

        // Only restore body scroll if we set it (don't interfere with cart drawer)
        if (document.body.style.overflow === 'hidden') {
          document.body.style.overflow = ''
        }
      }
    }

    async addVariantToCart (variantId) {
      this.enableLoading()

      try {
        const formData = new FormData()
        formData.append('id', variantId)
        formData.append('quantity', '1')

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })

        if (!response.ok) {
          throw new Error('Failed to add item to cart')
        }

        // Get updated cart data and trigger cart update
        const cartResponse = await fetch('/cart.js')
        const cartData = await cartResponse.json()

        // Trigger cart updated event
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }))

        // Update cart drawer if it exists
        const cartDrawerItems = document.querySelector('cart-drawer-items')
        if (cartDrawerItems) {
          const sectionsResponse = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
          const sectionsHtml = await sectionsResponse.text()

          // Update cart drawer content
          const cartDrawerElement = document.getElementById('CartDrawer')
          if (cartDrawerElement) {
            const parser = new DOMParser()
            const doc = parser.parseFromString(sectionsHtml, 'text/html')
            const newContent = doc.querySelector('.drawer__inner')

            if (newContent) {
              cartDrawerElement.querySelector('.drawer__inner').innerHTML = newContent.innerHTML

              // Reinitialize faders and complementary cross-sells
              setTimeout(() => {
                if (window.tentboxInitCartDrawerFaders) window.tentboxInitCartDrawerFaders(document)
                if (window.tentboxInitCartComplementaryCrossSells) window.tentboxInitCartComplementaryCrossSells(document)
              }, 100)
            }
          }

          // Update cart icon bubble
          const cartIconResponse = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`)
          const cartIconHtml = await cartIconResponse.text()
          const cartIconElement = document.getElementById('cart-icon-bubble')

          if (cartIconElement && cartIconHtml) {
            const iconDoc = parser.parseFromString(cartIconHtml, 'text/html')
            const newIconContent = iconDoc.querySelector('.shopify-section')
            if (newIconContent) {
              cartIconElement.innerHTML = newIconContent.innerHTML
            }
          }
        }

        this.showSuccess('Item added to cart')
      } catch (error) {
        console.error('Error adding to cart:', error)
        this.showError('Failed to add item to cart')
      } finally {
        this.disableLoading()
      }
    }

    async addSingleVariantToCart () {
      // For single variant products, use the first (and only) variant
      if (this.variantIds.length > 0) {
        await this.addVariantToCart(this.variantIds[0])
      }
    }

    closeModal () {
      this.hideModal()
    }

    // Cleanup when component is removed
    disconnectedCallback () {
      if (this.modal) {
        this.modal.remove()
      }
      if (this.handleEscapeKey) {
        document.removeEventListener('keydown', this.handleEscapeKey)
      }
    }

    formatPrice (price) {
      // Price is already in the correct format (e.g., 75.00 for £75)
      // Don't divide by 100 as it's not in cents
      const priceNum = parseFloat(price)
      const currency = window.Shopify?.currency?.active || 'USD'

      if (currency === 'EUR') {
        return `€${priceNum.toFixed(2)}`
      } else if (currency === 'GBP') {
        return `£${priceNum.toFixed(2)}`
      } else {
        return `$${priceNum.toFixed(2)}`
      }
    }

    showSuccess (message) {
      console.log(`[Cart Cross-sell] Success: ${message}`)
      // Could be enhanced with toast notifications
    }

    showError (message) {
      console.error(`[Cart Cross-sell] Error: ${message}`)
      // Could be enhanced with toast notifications
    }

    enableLoading () {
      if (this.button) {
        this.button.disabled = true
        this.button.setAttribute('aria-busy', 'true')
        this.button.classList.add('opacity-50')
      }
    }

    disableLoading () {
      if (this.button) {
        this.button.disabled = false
        this.button.setAttribute('aria-busy', 'false')
        this.button.classList.remove('opacity-50')
      }
    }
  }

  customElements.define('cart-cross-sell-button', CartCrossSellButton)
}
